import { StepName } from './step.type';

export enum StepType {
  ZipCode = 'zipCode',
  Radio = 'radio',
  Form = 'form',
}

export class Step {
  public title!: string;
  public name!: StepName;
  public type!: StepType;
  public attributes!: StepAttribute[];
  public nextStep?: StepName;
  public tcpa?: boolean;
}

interface StepAttribute {
  name: string;
  displayName?: string;
  validations?: {
    required?: boolean;
    email?: boolean;
    phone?: boolean;
    minLength?: number;
    maxLength?: number;
  };
  options?: StepOption[];
}

interface StepOption {
  key: string;
  value: any;
}
